// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Component/img/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleDemoDetailSty_loaderWrap__QyFx0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
}

.ScheduleDemoDetailSty_loader__7xBv6 {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ScheduleDemoDetailSty_spin__tHRea 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes ScheduleDemoDetailSty_spin__tHRea {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ScheduleDemoDetailSty_loadingText__clPJb {
  font-size: 1rem;
  color: #555;
}

.ScheduleDemoDetailSty_demoWrap__HtKkE {
  width: 100%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ScheduleDemoDetailSty_demoDetailContainer__WUtte {
  width: 90%;
  max-width: 800px;
  margin: 2rem auto;
  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 12px;
  padding: 50px 30px;
}

h2 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
}

.ScheduleDemoDetailSty_demoInfo__mhJG0 {
  margin: 2rem auto;
  padding: 1.5rem;
  background-color: #ddeeff;
  border-radius: 10px;
}

.ScheduleDemoDetailSty_infoRow__jAXqF {
  display: flex;
  padding: 0.75rem 0;
  border-bottom: 1px solid #eee;
}

.ScheduleDemoDetailSty_infoRow__jAXqF:last-child {
  border-bottom: none;
}

.ScheduleDemoDetailSty_label__1YRzf {
  flex: 1 1;
  font-weight: 600;
  color: #34495e;
}

.ScheduleDemoDetailSty_value__bsBZU {
  flex: 2 1;
  color: #2c3e50;
}

.ScheduleDemoDetailSty_demoLink__kDEYx {
  color: #2980b9;
  text-decoration: none;
  transition: color 0.2s;
}

.ScheduleDemoDetailSty_demoLink__kDEYx:hover {
  color: #1a5276;
  text-decoration: underline;
}

.ScheduleDemoDetailSty_rescheduleSection__B9Dpl {
  background-color: #ddeeff;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 2rem;
}

.ScheduleDemoDetailSty_rescheduleSection__B9Dpl h3 {
  margin-top: 0;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.ScheduleDemoDetailSty_formGroup__BKwrP {
  margin-bottom: 1.5rem;
}

.ScheduleDemoDetailSty_formGroup__BKwrP label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #495057;
}

.ScheduleDemoDetailSty_formGroup__BKwrP input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.ScheduleDemoDetailSty_formGroup__BKwrP input:focus {
  border-color: #3498db;
  outline: none;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

/* .rescheduleButton {
  background-color: #3498db;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
} */

.ScheduleDemoDetailSty_rescheduleButton__a2RhK:hover {
  background-color: #2b67ff;
}

.ScheduleDemoDetailSty_rescheduleButton__a2RhK:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.ScheduleDemoDetailSty_success__0Xsva {
  color: #27ae60;
  margin: 1rem 0;
  font-weight: 500;
  padding: 0.5rem;
  background-color: #eafaf1;
  border-radius: 4px;
}

.ScheduleDemoDetailSty_error__5eqSJ {
  color: #e74c3c;
  margin: 1rem 0;
  font-weight: 500;
  padding: 0.5rem;
  background-color: #fdeded;
  border-radius: 4px;
}

.ScheduleDemoDetailSty_backButton__xSRN- {
  background-color: #95a5a6;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;
}

.ScheduleDemoDetailSty_backButton__xSRN-:hover {
  background-color: #7f8c8d;
}

.ScheduleDemoDetailSty_rescheduleButton__a2RhK {
  width: 100%;
  height: 58px;
  margin-top: 36px;
  background-color: var(--primary-color);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ScheduleDemoDetailSty.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iEAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;;;;;;;;;GASG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC","sourcesContent":[".loaderWrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  text-align: center;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loadingText {\n  font-size: 1rem;\n  color: #555;\n}\n\n.demoWrap {\n  width: 100%;\n  height: 100vh;\n  background-image: url(\"../Component/img/loginbg.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.demoDetailContainer {\n  width: 90%;\n  max-width: 800px;\n  margin: 2rem auto;\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 12px;\n  padding: 50px 30px;\n}\n\nh2 {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n}\n\n.demoInfo {\n  margin: 2rem auto;\n  padding: 1.5rem;\n  background-color: #ddeeff;\n  border-radius: 10px;\n}\n\n.infoRow {\n  display: flex;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #eee;\n}\n\n.infoRow:last-child {\n  border-bottom: none;\n}\n\n.label {\n  flex: 1;\n  font-weight: 600;\n  color: #34495e;\n}\n\n.value {\n  flex: 2;\n  color: #2c3e50;\n}\n\n.demoLink {\n  color: #2980b9;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.demoLink:hover {\n  color: #1a5276;\n  text-decoration: underline;\n}\n\n.rescheduleSection {\n  background-color: #ddeeff;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 2rem;\n}\n\n.rescheduleSection h3 {\n  margin-top: 0;\n  color: #2c3e50;\n  margin-bottom: 1.5rem;\n}\n\n.formGroup {\n  margin-bottom: 1.5rem;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.formGroup input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.formGroup input:focus {\n  border-color: #3498db;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n/* .rescheduleButton {\n  background-color: #3498db;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n} */\n\n.rescheduleButton:hover {\n  background-color: #2b67ff;\n}\n\n.rescheduleButton:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.success {\n  color: #27ae60;\n  margin: 1rem 0;\n  font-weight: 500;\n  padding: 0.5rem;\n  background-color: #eafaf1;\n  border-radius: 4px;\n}\n\n.error {\n  color: #e74c3c;\n  margin: 1rem 0;\n  font-weight: 500;\n  padding: 0.5rem;\n  background-color: #fdeded;\n  border-radius: 4px;\n}\n\n.backButton {\n  background-color: #95a5a6;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.backButton:hover {\n  background-color: #7f8c8d;\n}\n\n.rescheduleButton {\n  width: 100%;\n  height: 58px;\n  margin-top: 36px;\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrap": `ScheduleDemoDetailSty_loaderWrap__QyFx0`,
	"loader": `ScheduleDemoDetailSty_loader__7xBv6`,
	"spin": `ScheduleDemoDetailSty_spin__tHRea`,
	"loadingText": `ScheduleDemoDetailSty_loadingText__clPJb`,
	"demoWrap": `ScheduleDemoDetailSty_demoWrap__HtKkE`,
	"demoDetailContainer": `ScheduleDemoDetailSty_demoDetailContainer__WUtte`,
	"demoInfo": `ScheduleDemoDetailSty_demoInfo__mhJG0`,
	"infoRow": `ScheduleDemoDetailSty_infoRow__jAXqF`,
	"label": `ScheduleDemoDetailSty_label__1YRzf`,
	"value": `ScheduleDemoDetailSty_value__bsBZU`,
	"demoLink": `ScheduleDemoDetailSty_demoLink__kDEYx`,
	"rescheduleSection": `ScheduleDemoDetailSty_rescheduleSection__B9Dpl`,
	"formGroup": `ScheduleDemoDetailSty_formGroup__BKwrP`,
	"rescheduleButton": `ScheduleDemoDetailSty_rescheduleButton__a2RhK`,
	"success": `ScheduleDemoDetailSty_success__0Xsva`,
	"error": `ScheduleDemoDetailSty_error__5eqSJ`,
	"backButton": `ScheduleDemoDetailSty_backButton__xSRN-`
};
export default ___CSS_LOADER_EXPORT___;
